<template>
  <div class="view pa24">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto">
      <el-form-item :label="$t('addedServices', 'selectCategory')" prop="settingId">
        <el-select
          v-model="ruleForm.settingId"
          :placeholder="$t('addedServices', 'pleaseSelect')"
          style="width: 400px"
        >
          <el-option
            v-for="item in options"
            :key="item.settingId"
            :label="item.name"
            :value="item.settingId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addedServices', 'demandDescription')" prop="description">
        <el-input
          type="textarea"
          :placeholder="$t('addedServices', 'pleaseEnterContent')"
          v-model="ruleForm.description"
          maxlength="200"
          rows="4"
          style="width: 400px"
          show-word-limit
        >
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('addedServices', 'addImage')">
        <el-upload
          action="https://api.domo.hk/file/uploadObjectOSS"
          list-type="picture-card"
          :on-progress="handProgress"
          :on-success="handleSuccess"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          :file-list="ruleForm.fileList"
          :limit="6"
        >
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">
            {{ $t('addedServices', 'uploadImageTip2') }}
          </div>
        </el-upload>
        <el-dialog
          :visible.sync="dialogVisible"
          :modal-append-to-body="false"
          :destroy-on-close="true"
        >
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </el-form-item>
      <el-form-item :label="$t('addedServices', 'remarkLabel')" prop="note">
        <el-input
          type="text"
          :placeholder="$t('addedServices', 'pleaseEnterContent')"
          maxlength="50"
          v-model="ruleForm.note"
          style="width: 400px"
          show-word-limit
        >
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('addedServices', 'location')" prop="address">
        <el-input
          id="suggestId"
          type="text"
          :placeholder="$t('addedServices', 'pleaseEnterAddress')"
          v-model="ruleForm.address"
          maxlength="50"
          @change="theLocation"
          style="width: 400px"
          show-word-limit
        />
        <div
          id="baidumap"
          style="width: 400px; height: 400px; margin-top: 10px"
        ></div>
      </el-form-item>
      <el-form-item>
        <div class="flex-a-c">
          <el-checkbox v-model="radio"></el-checkbox>
          <a style="margin-left:10px" @click="userAgreement = !userAgreement">{{ $t('addedServices', 'userAgreement') }}</a>
        </div>
        
      </el-form-item>
    </el-form>
    <el-row align="right" style="width: 800px; text-align: right">
      <el-button type="primary" @click="saveForm('1')">{{ $t('addedServices', 'saveToDraft') }}</el-button>
      <el-button type="primary" @click="saveForm('0')">{{ $t('addedServices', 'publish') }}</el-button>
    </el-row>
    <el-dialog
      :title="$t('addedServices', 'userAgreementTitle')"
      :visible.sync="userAgreement"
      append-to-body
      width="50%"
      center>
      <p class="fwbold mb15">{{ $t('addedServices', 'userAgreementContent1') }}</p>
      <p class="mb15">{{ $t('addedServices', 'userAgreementContent2') }}</p>
      <p class="mb15">{{ $t('addedServices', 'userAgreementContent3') }}</p>
      <p class="mb15">{{ $t('addedServices', 'userAgreementContent4') }}</p>
      <p class="mb15">{{ $t('addedServices', 'userAgreementContent5') }}</p>
      <p class="mb15">{{ $t('addedServices', 'userAgreementContent6') }}</p>
      <p class="mb15">{{ $t('addedServices', 'userAgreementContent7') }}</p>
      <p class="mb15">{{ $t('addedServices', 'userAgreementContent8') }}</p>
      <p class="mb15">{{ $t('addedServices', 'userAgreementContent9') }}</p>
      <p class="mb15">{{ $t('addedServices', 'userAgreementContent10') }}</p>
      <p class="mb15">{{ $t('addedServices', 'userAgreementContent11') }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="userAgreement = false,radio=false">{{ $t('addedServices', 'cancel') }}</el-button>
        <el-button type="primary" @click="userAgreement = false,radio=true">{{ $t('addedServices', 'confirm') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
let ac;
import i18nMixin from '@/mixins/i18nMixin';
import {
  queryAllClassification,
  addDemandSquare,
  queryDemandSquare,
  updateDemandSquare,
} from "@/api/addedServices";
export default {
  mixins: [i18nMixin],
  data() {
    return {
      ruleForm: {
        settingId: "",
        description: "",
        note: "",
        address: "",
        fileList: [],
      },
      rules: {
        settingId: [{ required: true, message: this.$t('addedServices', 'pleaseSelectCategory') }],
        address: [{ required: true, message: this.$t('addedServices', 'pleaseEnterLocation') }],
      },
      radio: false,
      options: [],
      dialogImageUrl: "",
      dialogVisible: false,
      userAgreement:false,
      map: {}, //赋值地图
      local: {}, //搜索
    };
  },
  created() {
    const { squareId } = this.$route.query;
    this.queryAllClassification();
    if (squareId) {
      this.queryDemandSquare(squareId);
    }
  },
  mounted() {
    this.createdMap();
  },
  beforeDestroy() {
    if (ac && typeof ac.removeEventListener === 'function') {
      ac.removeEventListener("onConfirm", this.setValue);
    }
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    /**@method 创建地图 */
    createdMap() {
      let navigationControl = new BMap.NavigationControl({
        // 靠左上角位置
        anchor: BMAP_ANCHOR_TOP_LEFT,
        // LARGE类型
        type: BMAP_NAVIGATION_CONTROL_LARGE,
        // 启用显示定位
        enableGeolocation: true,
      });
      this.map = new BMap.Map("baidumap");
      this.map.centerAndZoom("北京", 12);
      this.map.addControl(navigationControl);

      ac = new BMap.Autocomplete({
        //建立一个自动完成的对象
        input: "suggestId",
        location: this.map,
      });
      ac.addEventListener("onConfirm", this.setValue);
    },
    setValue(e) {
      const {
        item: { value },
      } = e;
      this.ruleForm.address = `${value.city}${value.district}${value.business}`;
    },
    handProgress(event, file, fileList) {
      this.$message({
        message: this.$t('addedServices', 'uploading'),
      });
    },
    handleSuccess(response, file, fileList) {
      this.$message.closeAll();
      this.$message({
        message: this.$t('addedServices', 'uploadSuccess'),
        type: "success",
      });
      this.ruleForm.fileList = fileList;
    },
    myFun() {
      let pp = this.local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
      this.map.centerAndZoom(pp, 18);
      this.map.addOverlay(new BMap.Marker(pp)); //添加标注
      this.ruleForm.gps = JSON.stringify(pp);
    },
    theLocation(val) {
      this.map.clearOverlays(); //清除地图上所有覆盖物

      this.local = new BMap.LocalSearch(this.map, {
        //智能搜索
        onSearchComplete: this.myFun,
      });
      this.local.search(val);
    },
    /**@method 获取编辑数据 */
    async queryDemandSquare(squareId) {
      const result = await queryDemandSquare({ squareId });
      const {
        settingId,
        description,
        images,
        note,
        address,
        createdUserId,
        companyId,
      } = result.data;
      const imgs = JSON.parse(images);
      this.ruleForm = {
        settingId,
        description,
        fileList: imgs.map((item) => ({
          url: item,
          response: {
            data: item,
          },
        })),
        note,
        address,
        createdUserId,
        companyId,
      };
    },
    /**@method  获取分类*/
    async queryAllClassification() {
      try {
        const result = await queryAllClassification({ dataType: 1 });
        this.options = result?.data;
      } catch (error) {
        console.log(error);
      }
    },
    /**@method 发布 */
    saveForm(val) {
      let than = this
      const { squareId } = this.$route.query;
      let data = {
        ...this.ruleForm,
        source: "web",
        isDraft: val == "0" ? false : true,
        status: 0,
        images: this.ruleForm.fileList.map((item) =>
          item.response.data.indexOf("https") >= 0
            ? item.response.data
            : `https://one-stand-domo.oss-cn-shenzhen.aliyuncs.com/${item.response.data}`
        ),
      };
      if (!this.radio) {
        this.$message({
          showClose: true,
          message: this.$t('addedServices', 'pleaseCheckUserAgreement'),
          type: "warning",
        });
        return;
      }
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          if (squareId) {
            //保存编辑
            await updateDemandSquare(
              { ...data, squareId },
              { showLoading: true }
            );
          } else {
            //添加请求
            addDemandSquare(data, { showLoading: true })
            .then(res=>{
              this.$message({
                type:'success',
                message: this.$t('addedServices', 'publishSuccess')
              })
              than.$router.push({ path: "/myNeeds" });
            })
            .catch(err=>{
              if (err.code == 201) {
                than.$message({message:err.message || this.$t('addedServices', 'publishFailed'), type:'warning'});
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>